<template>
  <LoginWrapper>
    <div class="inner_wrap">
      <div class="box_title">
        <h2>로그인</h2>
        <p class="guide_txt">회원 로그인 후 서비스 이용이 가능합니다.</p>
      </div>
      <ul class="form_wrap">
        <!-- 아이디 -->
        <li class="input_wrap">
          <input
            id="user_id"
            v-model="username"
            class="input_t"
            :class="{ 'has-input': usernameHasInput }"
            type="text"
            placeholder="example@example.com"
          />
        </li>
        <!-- 비밀번호 -->
        <li class="input_wrap encryption">
          <input
            id="user_password"
            v-model="password"
            class="input_t"
            :class="{ 'has-input': passwordHasInput }"
            :type="inputType"
            placeholder="비밀번호"
            @keydown.enter="login"
          />
          <button type="button" class="password_toggle" @click="passwordToggle">
            <div v-if="inputType === 'password'">
              <img
                src="@/assets/images/login_join/encryption.png"
                alt="비밀번호토글닫힘"
              />
            </div>
            <div v-else>
              <img
                src="@/assets/images/login_join/encryption_on.png"
                alt="비밀번호토글열림"
              />
            </div>
          </button>
        </li>
        <li>
          <p class="error_style">
            {{ getAuthErrorMessage }}
          </p>
        </li>
        <!-- 아이디 저장 -->
        <li class="input_wrap chk_round save_wrap">
          <div class="text_label">
            <input
              id="saveid"
              v-model="saveUsername"
              type="checkbox"
              name="log_save"
            />
            <label for="saveid">아이디 저장</label>
          </div>
          <p class="guide_txt">
            공용 PC 이용 후 개인정보 보호를 위해 로그아웃 해주세요.
          </p>
        </li>
        <!-- 로그인 -->
        <li class="btn_wrap mt_style">
          <button
            class="box_btn login_btn"
            :class="{ dull: !isValid }"
            :disabled="!isValid"
            @click="login"
          >
            로그인
          </button>
        </li>
        <!-- 찾기 -->
        <li class="input_wrap chk_round find_wrap">
          <ul class="board_sort">
            <li class="btn_wrap">
              <router-link :to="{ name: 'id_lost' }"> 아이디 찾기 </router-link>
            </li>
            <li class="btn_wrap">
              <router-link :to="{ name: 'password_lost' }">
                비밀번호 찾기
              </router-link>
            </li>
            <li class="btn_wrap">
              <router-link :to="{ name: 'sign_up' }"> 회원가입 </router-link>
            </li>
          </ul>
        </li>
      </ul>
      <div class="sns_wrap">
        <h2 class="title">SNS 로그인</h2>
        <div class="sns_inner">
          <a href="javascript:void(0)" class="kakao" @click="kakao_login">
            <img src="@/assets/images/login_join/btn_kakao.png" alt="카카오" />
          </a>
          <a href="javascript:void(0)" class="naver" @click="naver_login">
            <img src="@/assets/images/login_join/btn_naver.png" alt="네이버" />
          </a>
        </div>
      </div>
      <div class="box">
        <div class="btn_wrap">
          <p class="guide_txt member_qa">아직 캠퍼스북 회원이 아니신가요?</p>
          <router-link :to="{ name: 'sign_up' }" class="box_btn member_join">
            회원가입
          </router-link>
        </div>
      </div>
    </div>
    <!-- ERROR MODAL -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                ><span>{{ $t('library.sidebar.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ getAuthErrorMessage }}
              </p>
            </div>
            <div class="btnWrap">
              <button class="box_btn" @click="toggleErrorModal">
                <span class="an_t">{{ $t('library.deletemodal.close') }}</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </LoginWrapper>
</template>
<script>
import LoginWrapper from '@/components/auth/LoginWrapper.vue'
import { AUTH_LOGIN, AUTH_FAILURE } from '@/store/types'
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  components: { LoginWrapper },
  data() {
    return {
      username: '',
      password: '',
      saveUsername: false,
      showErrorModal: false,
      usernameHasInput: false,
      passwordHasInput: false,
      inputType: 'password'
    }
  },
  computed: {
    ...mapGetters(['getAuthErrorMessage']),
    isValid() {
      return !(!this.username || !this.password)
    },
    isBeforeRoute() {
      if (this.$store.getters.getBeforeRouteName) {
        return this.$store.getters.getBeforeRouteName
      }
      return false
    }
  },
  watch: {
    username(put) {
      this.usernameHasInput = put.length > 0
    },
    password(put) {
      this.passwordHasInput = put.length > 0
    }
  },
  beforeMount() {
    this.$store.commit('RESET_AUTH_ERROR')
  },
  mounted() {
    const username = localStorage.getItem('username')
    if (username) {
      this.username = username
    }
  },
  methods: {
    passwordToggle() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password'
    },
    // 소셜 로그인 추가
    kakao_login() {
      const redirect_uri =
        'https://www.campusbook.co.kr/login/oauth2/code/kakao'
      const client_id = '7ddb8fda4b0731c922688ed932a42fb3'
      const auth_url = `https://o2o-gwapi.campusbook.co.kr/oauth2/authorize/kakao?response_type=code&redirect_uri=${redirect_uri}&client_id=${client_id}`
      window.location.href = auth_url
    },
    naver_login() {
      const redirect_uri =
        'https://www.campusbook.co.kr/login/oauth2/code/naver'
      const client_id = '7JIYwgFBkaGiQ5svVJz5g'
      const auth_url = `https://o2o-gwapi.campusbook.co.kr/oauth2/authorize/naver?response_type=code&redirect_uri=${redirect_uri}&client_id=${client_id}`
      window.location.href = auth_url
    },
    toggleErrorModal() {
      this.showErrorModal = !this.showErrorModal
    },
    async login() {
      const { username, password, saveUsername } = this
      const that = this
      try {
        if (!username || !password) {
          this.$store.commit(
            AUTH_FAILURE,
            '아이디와 비밀번호를 모두 입력해주세요.'
          )
          //this.toggleErrorModal()
          return
        }
        await that.$store.dispatch(AUTH_LOGIN, { username, password })

        if (saveUsername) {
          localStorage.setItem('username', username)
        } else {
          localStorage.removeItem('username')
        }
        // this.$router.push({ name: 'store' })
        if (this.isBeforeRoute) {
          this.$router.push({
            name: this.isBeforeRoute.name,
            params: this.isBeforeRoute.params
          })
        } else {
          this.$router.push({ name: 'store' })
        }
      } catch (err) {
        if (!err.response) {
          this.$store.commit(
            AUTH_FAILURE,
            '아이디(이메일) 와 비밀번호를 형식에 맞게 입력해주세요.'
          )
        }
        //this.toggleErrorModal()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text_label input[type='checkbox'] + em {
  background-image: none !important;
}
.btnWrap {
  margin-top: 50px;
  padding: 0px 25px 25px 25px;
  .box_btn {
    width: 100%;
  }
}
.ly_inner {
  padding: 22px 25px 0px 25px !important;
}
.box_wrap .box + .box {
  position: relative;
  padding: 40px 56px 0px 56px;
  margin-top: 40px;
  border-top: 1px solid #d6e7f1;
}
.form_wrap > li + li {
  margin-top: 12px;
}
.input_wrap {
  & + .btn_wrap {
    &.mt_style {
      margin-top: 25px;
    }
  }
  .password_toggle {
    content: '';
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    > img {
      width: 100%;
    }
  }
  &.save_wrap {
    margin-top: 12px;
    .guide_txt {
      display: none;
      margin-top: 27px;
      text-align: left;
      word-break: normal;
      font-family: 'pretendard-light';
      font-size: 16px;
      color: #c9c9c9;
    }
  }
}
.find_wrap {
  .board_sort {
    width: 100%;
    text-align: center;
    margin-bottom: 15px;
    li {
      position: relative;
      display: inline-block;
      min-height: 24px;
      > a {
        letter-spacing: -0.1px;
        font-family: 'pretendard-light';
        font-size: 16px;
      }
      & + li {
        margin-left: 16px;
        padding-left: 16px;
        &::before {
          content: '';
          position: absolute;
          left: -1px;
          top: 50%;
          width: 1px;
          height: 12px;
          margin-top: -8px;
          border-left: 1px solid #d2d2d2;
        }
      }
    }
  }
}
.sns_wrap {
  > .title {
    display: block;
    margin-bottom: 25px;
    padding-top: 27px;
    border-top: 2px solid #c9c9c9;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 24px;
    color: #1c1c1c;
  }
  .sns_inner {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 40px;
    > a {
      width: 55px;
      height: 55px;
      > img {
        width: 100%;
      }
      &.kakao {
        border: 1px;
      }
      &.naver {
        border: 1px;
      }
    }
  }
}
.error_style {
  font-weight: 600;
  font-size: 13px;
  color: #f31919;
}
.login_btn {
  color: #fff;
}
.member_join {
  color: #008df3;
}
.login_btn,
.member_join {
  line-height: 56px;
  letter-spacing: 0;
  font-size: 18px;
}
@media (min-width: 480px) {
  .input_wrap.save_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &::after {
      content: none;
    }
    .guide_txt {
      display: block;
      margin-top: 0;
    }
  }
}
</style>
